import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3a92bd75&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a92bd75')) {
      api.createRecord('3a92bd75', component.options)
    } else {
      api.reload('3a92bd75', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3a92bd75&", function () {
      api.rerender('3a92bd75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/historicalTenant/detail.vue"
export default component.exports